// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_LeV","cls2":"CreateSocialItemModal-cls2_rJP CreateSocialItemModal-cls1_LeV"};